import { TFunction } from 'i18next';

/**
 * Helper function to make it easier to create a Helmet titleTemplate for a section.
 */
export const titleTemplateParams = (t: TFunction) => ({
  prefix: '%s:',
  suffix: '| ' + t('metadata.title.default', 'My Rotary'),
});
